import styled from 'styled-components';
import {SectionHeader} from '../../stories/components/CommonStyleUtils/dwebCommon.styles';

const StyledModalHeader = styled(SectionHeader)(
  props => `
  padding: ${props.theme.spacing.custom(30)};
  border-bottom: .1rem solid ${props.theme.colors.goBrandBlue.light};
`,
);

export default StyledModalHeader;
